import { Routes } from '@angular/router';

import { Login } from './pages/login/login';
import { Dashboard } from './pages/dashboard/dashboard';
import { BuyerForm } from './pages/buyer-form/buyer-form';
import { AdminDashboard } from './pages/admin-dashboard/admin-dashboard';
import { LandingPage } from './pages/landing-page/landing-page';
// import { AdminGuard } from '././admin.guard';

export const routes: Routes = [
  // { path: 'login', component: Login },
  { path: 'dashboard', component: Dashboard },
  { path: 'landingPage', component: LandingPage },
  // { path: 'buyer_form', component: BuyerForm },
  // { path: 'admin-panel', component: AdminDashboard, canActivate: [AdminGuard] },

  // default route
  { path: '', redirectTo: 'landingPage', pathMatch: 'full' },

  // fallback
  { path: '**', redirectTo: 'landingPage' }
];